import { computed, makeObservable, observable } from "mobx";
import { BannerUserBaseInfo, BannerUserStatisticsInfo, Sets } from "@/types/mySpace";
import { ABCStore } from "@noli/business";
import { getSetsImgs, getSetsList, getUserBaseInfo, getUserStatisticsInfo } from "../api/mySpace";
import { cloneDeep } from "lodash";

const PAGE_NUM = 20;

export interface IOtherSpaceStore {
  loading: boolean;
  reelsList: any[];
  reelsNoMore: boolean;
  bannerUserBaseInfo: BannerUserBaseInfo | null;
  bannerUserStatisticsInfo: BannerUserStatisticsInfo | null;
  reelsFirstLoad: boolean;
}

class OtherSpaceStore extends ABCStore<IOtherSpaceStore> implements IOtherSpaceStore {
  loading = false;
  reelsList: any[] = [];
  reelsNoMore = false;
  bannerUserBaseInfo = null;
  bannerUserStatisticsInfo = null;
  reelsFirstLoad = true;

  constructor() {
    super();
    this.reelsList = [];
    makeObservable(this, {
      loading: observable,
      reelsList: observable,
      reelsNoMore: observable,
      bannerUserBaseInfo: observable,
      bannerUserStatisticsInfo: observable,
      reelsFirstLoad: observable,
    });
  }

  get info(): IOtherSpaceStore {
    return this;
  }

  public setLoading(loading: boolean) {
    this.loading = loading;
  }

  public getReelsList = async (pageIndex: number, userId: number, successCallback?: () => void) => {
    console.log("pageIndex: ", pageIndex);
    this.loading = true;
    const res = await getSetsImgs({
      page_index: pageIndex,
      page_size: PAGE_NUM,
      user_id: Number(userId),
    });
    if (res.code == 0 && res.data) {
      this.reelsList = [...this.reelsList, ...res.data.opus_data];
      // setCurIdx(pageIndex + 1);
      this.reelsNoMore = pageIndex * PAGE_NUM >= res.data.total;
      successCallback?.();
    } else {
      // network error
    }
    if (this.reelsFirstLoad) this.reelsFirstLoad = false;
    this.loading = false;
  };

  public setReelsList = (list: Sets[]) => {
    this.reelsList = list;
  };

  public updateReelsImgInfo = async (idxInList: number, userId: number) => {
    // 获取改变的 图片信息 并更新 ReelsList
    console.log("idxInList", idxInList);
    const res = await getSetsImgs({
      page_index: idxInList + 1, // 第0项 是 第一页的第一个
      page_size: 1,
      user_id: Number(userId),
    });

    if (res.code == 0 && res.data) {
      const newList = cloneDeep(this.reelsList);
      newList.splice(idxInList, 1, res.data.opus_data[0]);
      this.reelsList = newList;
    } else {
      //error
    }
  };

  getBannerInfo = async (userId: number) => {
    console.log(userId);
    const baseInfoRes = await getUserBaseInfo({ user_id: userId });
    const statisticsInfoRes = await getUserStatisticsInfo({ user_id: String(userId) });
    if (baseInfoRes.code === 0 && statisticsInfoRes.code == 0) {
      this.bannerUserBaseInfo = baseInfoRes.data;
      this.bannerUserStatisticsInfo = statisticsInfoRes.data;
      document.title = `画宇宙 - ${baseInfoRes.data.nickname} - 艺术家主页`;
    } else {
      // error
    }
  };
}

export const otherSpaceStore = new OtherSpaceStore();
